const projectRouter = [
    {
        path: "list-project",
        name: "project",
        component: () => import("@/views/admin/project"),
        default: true,
        meta: {
            model: "project",
            // requiresAuth: true,
        },
    },
    {
        path: "list-project/add",
        name: "addProject",
        component: () => import("@/views/admin/project/function"),
        default: true,
        meta: {
            model: "project",
            // requiresAuth: true,
        },
    },
    {
        path: "list-project/edit/:id",
        name: "editProject",
        component: () => import("@/views/admin/project/function"),
        default: true,
        meta: {
            model: "project",
            // requiresAuth: true,
        },
    },
    {
        path: "list-project/detail/:id",
        name: "viewProject",
        component: () => import("@/views/admin/project/view/function"),
        default: true,
        meta: {
            model: "project",
            // requiresAuth: true,
        },
    }
]
export default projectRouter;